/* eslint-disable prefer-rest-params */

import { isEmpty } from 'lodash-es'

function baiduSeo() {
  ;(window as any)._hmt = (window as any)._hmt || []
  const hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?1406538bc7301a095b147c6a0a603e59'
  const s = document.getElementsByTagName('script')[0]
  s.parentNode?.insertBefore(hm, s)
}

/**
 * 用户行为分析
 */
function hotJar(area: 'CN' | 'HK' | 'US') {
  ;(function (h, o, t, j) {
    // let id = 4935122
    let id = 5178244

    if (area === 'HK') {
      id = 5012299
    } else if (area === 'US') {
      id = 5012578
    }

    h.hj =
      h.hj ||
      function () {
        ;(h.hj.q = h.hj.q || []).push(arguments)
      }
    h._hjSettings = { hjid: id, hjsv: 6 }
    const a = o.getElementsByTagName('head')[0]
    const r = o.createElement('script')
    r.async = true
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    a.appendChild(r)
  })(window as any, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
}

function seo360() {
  ;(function (b, a, e, h, f, c) {
    b[h] =
      b[h] ||
      function () {
        ;(b[h].c = b[h].c || []).push(arguments)
      }
    b[h].s = !!c
    const g = a.getElementsByTagName(e)[0]
    const s = a.createElement('script')
    s.src = '//s.union.360.cn/' + f + '.js'
    s.defer = !0
    s.async = !0
    g.parentNode?.insertBefore(s, g)
  })(window as any, document, 'script', '_qha', 560683, false)
}

export interface SeoData {
  title?: string
  path: string
  description?: string
  keywords?: string
}

export function useSeoData() {
  return useState<SeoData[]>('seoData', () => [])
}

export function useSeo() {
  const runtimeConfig = useRuntimeConfig()
  const request = useRequestURL()

  if (runtimeConfig.public.privatization) {
    return
  }

  if (import.meta.client && runtimeConfig.public.env === 'production') {
    hotJar(runtimeConfig.public.area as any)

    if (runtimeConfig.public.area === 'CN') {
      // 国内地区才有百度, 360
      baiduSeo()
      seo360()
    }
  }

  const route = useRoute()
  const seoData = useSeoData()
  const { $t } = useNuxtApp()

  const targetSeoData = computed(() => {
    return seoData.value.find((item) => {
      if (routePathMatch(route.path, item.path)) {
        return true
      }
      return false
    })
  })

  const DEFAULT_TITLE = $t('seo-common-title')

  const DEFAULT_DESCRIPTION = $t('seo-common-description')

  const DEFAULT_KEYWORDS = $t('seo-common-keywords')

  const title = computed(() => {
    if (targetSeoData.value) {
      return targetSeoData.value.title || DEFAULT_TITLE
    }

    return DEFAULT_TITLE
  })

  const description = computed(() => {
    if (targetSeoData.value) {
      return targetSeoData.value.description || DEFAULT_DESCRIPTION
    }

    return DEFAULT_DESCRIPTION
  })

  const keywords = computed(() => {
    if (targetSeoData.value) {
      return targetSeoData.value.keywords || DEFAULT_KEYWORDS
    }

    return DEFAULT_KEYWORDS
  })

  useSeoMeta(
    {
      title,
      ogTitle: title,

      description,
      ogDescription: description,

      keywords,
    },
    {
      tagPriority: -20,
      tagPosition: 'head',
    }
  )

  // 补上  canonical & 内网 和 pre 禁止爬虫
  useHead(
    {
      meta: [
        runtimeConfig.public.env !== 'production'
          ? {
              name: 'robots',
              content: 'noindex, nofollow',
            }
          : null,
      ].filter((v) => !isEmpty(v)),
      link: [
        {
          rel: 'canonical',
          href: request.origin + route.path,
        },
      ],
    },
    {
      tagPriority: -20,
      tagPosition: 'head',
    }
  )
}

export function useWatchPageSeoData(
  data: Ref<
    | {
        seo_description?: string
        seo_keywords?: string
        seo_title?: string
      }
    | null
    | undefined
  >
) {
  const seoData = useSeoData()
  const route = useRoute()

  watch(
    () => data.value,
    (val) => {
      if (val) {
        const originSeoData = seoData.value.find((item) =>
          routePathMatch(route.path, item.path)
        )
        const currentSeoData: SeoData = {
          path: route.path,
        }

        if (val.seo_description) {
          currentSeoData.description = val.seo_description
        }

        if (val.seo_keywords) {
          currentSeoData.keywords = val.seo_keywords
        }

        if (val.seo_title) {
          currentSeoData.title = val.seo_title
        }

        if (originSeoData) {
          Object.assign(originSeoData, currentSeoData)
        } else {
          seoData.value = [...seoData.value, currentSeoData]
        }
      }
    },
    { immediate: true, flush: 'sync' }
  )
}
